import { EventEmitter, Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { RetailerUser } from 'src/models/ClientUser';
import { ApiService } from './api.service';
import firebase from 'firebase/app';

@Injectable({
  providedIn: 'root'
})
export class LocalitiAuthService {

  constructor(private auth: AngularFireAuth, private api: ApiService) { 
    this.setUserPromise(true);
    auth.user.subscribe(async u => {
      if (u != this.authUser) {
        console.log("update of user");
        this.authUser = u;
        this.setUserPromise();
      }
    });    
  }

  userRefresh = new EventEmitter(true);
  async forceReauth() {
    this.setUserPromise(false, true);
    this.userRefresh.emit();
  }
  async signInWithPopup(provider: firebase.auth.AuthProvider) : Promise<RetailerUser> {
    
    const res = await this.auth.signInWithPopup(provider);
    if (res && res.user) {
      this.authUser = res.user;
      this.setUserPromise();
      return this.user;
    }
    
  }
  
  private setUserPromise(firstGet?:boolean, forceRefresh?:boolean) {
      this.user = new Promise<RetailerUser|null>(async (res, rej) => {
        console.log("doing user promise");
        if (firstGet && !this.authUser) {
          console.log("is first get!");
          try {
          this.authUser = await this.auth.user.pipe(take(1)).toPromise();
          } catch (e) {
            console.error("error first time");
            console.error(e);
          }
        }
        if (!this.authUser) {
          console.log("auth user is null");
          return res(null);        
        }
        try {
          console.log("updating user");
          const usr : RetailerUser = JSON.parse(JSON.stringify(<RetailerUser>this.authUser));
          console.log("getting client user")
          usr.clientUser = await this.api.getClientUser();
          console.log("getting claims")
          usr.localitiClaims = await this.api.getClaims(forceRefresh);
          console.log("resolving with " + JSON.stringify(usr));
          res(usr);
        } catch (e) {
          console.error("error updating user stuff");
          console.error(e);
          rej(e);
        }
      })
      this.isLoggedIn = this.user.then(x=> x?true:false);
      this.isClient = this.user.then(x=> x?x.localitiClaims.client:false);
      this.isRetailer = this.user.then(x=> x?x.localitiClaims.retailer:false);
      this.isGlobalAdmin = this.user.then(x=> x?x.localitiClaims.global_admin:false);  
  }
  private authUser : firebase.User | null = null;
  
  isLoggedIn : Promise<boolean>;
  isClient : Promise<boolean>;
  isRetailer : Promise<boolean>;
  isGlobalAdmin : Promise<boolean>;
//  private userPromise : Promise<RetailerUser|null>|null = null;
  public user: Promise<RetailerUser|null> ;
  
  async signOut() {
    await this.auth.signOut();
    this.authUser = null;
    this.setUserPromise();
    
  }
}
